import axios from 'axios'

/**
 * 運営から全社へ出すお知らせ。
 *
 * 読むほうはダッシュボードの口（/dashboard）に含まれる。ここは書く側で、
 * 経路表で `/platform-notices` は PLATFORM_SUPER_ADMIN と、
 * PROVIDER_NOTICE_HOLIDAY_MANAGE を持つ PLATFORM_OPERATIONS_ADMIN に開いている（2026-09-30）。
 *
 * 一覧の各行には、書いた人が入れた「掲載を終える日」（lastDay、YYYY-MM-DD）が付く。
 * expiresAt はその翌日の 0:00（その日の終わりまで出すため）なので、日付にして出さない。
 */
const origin = process.env.VUE_APP_API_ORIGIN
const get = path => axios.get(origin + path).then(response => response.data)
const post = (path, payload) =>
  axios.post(origin + path, payload).then(response => response.data)

export default {
  /** 一覧。**期限の切れたものも含む。**出した覚えを確かめられるように。 */
  list () {
    return get('/platform-notices')
  },

  /** 1件出す。掲載を終える日は必須。 */
  publish (payload) {
    return post('/platform-notices', payload)
  },

  /** 出すのをやめる。**行は消さない。** */
  end (id) {
    return post('/platform-notices/' + id + '/end')
  }
}
